import styled from "styled-components";
import { COLORS } from "../../constants/colors";

interface Props {
    width: string;
}

const MarginInput = styled.div<Props>`
    display: flex;
    flex-direction: column;
    width: ${(props) => props.width};
    
    label {
        font-size: 1.15em;
        color: ${COLORS.blue_main(1)};
        margin-bottom: 5px;
    }
`;

export default MarginInput;